import { c as _c } from "react/compiler-runtime";
import isEqual from 'lodash/isEqual';
import { useBuilder } from '../store/provider';
export const useSkillsSave = () => {
  const $ = _c(5);
  const {
    state,
    mutateOp
  } = useBuilder();
  let t0;
  if ($[0] !== mutateOp || $[1] !== state.bundle || $[2] !== state.current?.isHistoricalPreview || $[3] !== state.savedBundle) {
    t0 = () => {
      if (state.current?.isHistoricalPreview) {
        return;
      }
      if (!state.savedBundle) {
        return;
      }
      if (isEqual(state.bundle.skills, state.savedBundle.skills)) {
        return;
      }
      mutateOp({
        kind: "update_skills",
        skills: state.bundle.skills
      });
    };
    $[0] = mutateOp;
    $[1] = state.bundle;
    $[2] = state.current?.isHistoricalPreview;
    $[3] = state.savedBundle;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};